/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-14T10:22:53.393Z by lizhutang (lizhutang@spolo.org)

'use strict'

/**
layerjs模块用于编辑画布布局模式。运行期库采用[layerjs](https://layerjs.org/)
@module layerjs
*/

import loadTraits from './traits'
import loadComponents from './components'
import loadBlocks from './blocks'

export default (editor, opts = {}) => {
  const optsLabels = opts.labels || {}
  const optsBlocks = opts.blocks || {}

  const defaultBlocks = {
    // LAYOUT
    stage: true,
    layer: true,
    frame: true
  }

  const defaultLabels = {
    // LAYOUT
    stage: '画布容器',
    layer: '画布块',
    frame: '画布块内容',
    absframe: '绝对定位块'
  }

  let options = { ...{
    blocks: Object.assign(defaultBlocks, optsBlocks),
    labels: Object.assign(defaultLabels, optsLabels)
  },
  ...opts }

  // Add components
  loadTraits(editor, options)
  loadComponents(editor, options)
  loadBlocks(editor, options)

  // TODO Remove
  // editor.on('load', () => editor.addComponents(`<div style="margin:0 100px; padding:25px;">Content loaded from the plugin</div>`))
}
